import { render, staticRenderFns } from "./aggiungiFamiliare.vue?vue&type=template&id=fff37a54&"
import script from "./aggiungiFamiliare.vue?vue&type=script&lang=js&"
export * from "./aggiungiFamiliare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports